import { CampaignGoalStats, PerformantCampaignVariant } from 'modules/iterableGoals/types';
import { Contributions, Delivery, Link, Thumbnail, Title } from './items';
import { ListItemWrapper, ListRowWrapper, ListWrapper } from './Styled';

type PerformantListProp = {
  data: CampaignGoalStats[];
  campaignVariant: PerformantCampaignVariant;
};

export const PerformantList = ({ campaignVariant, data }: PerformantListProp) => {
  return (
    <ListWrapper>
      {data.map(
        ({
          id,
          type,
          name,
          thumbnail,
          messageMedium,
          startedAt,
          contributions,
          revenue,
          sends,
          delivered,
        }) => (
          <ListRowWrapper key={id} data-test="performant-campaign-row">
            <ListItemWrapper data-test="performant-campaign-contributions">
              <Contributions
                campaignVariant={campaignVariant}
                contributions={contributions}
                revenue={revenue}
              />
            </ListItemWrapper>
            <ListItemWrapper data-test="performant-campaign-thumbnail">
              <Thumbnail thumbnailSrc={thumbnail} />
            </ListItemWrapper>
            <ListItemWrapper data-test="performant-campaign-title">
              <Title
                campaignName={name}
                type={type}
                messageMedium={messageMedium}
                launchDate={startedAt}
              />
            </ListItemWrapper>
            <ListItemWrapper data-test="performant-campaign-delivery">
              <Delivery deliveredCount={sends} deliveredRate={delivered} />
            </ListItemWrapper>
            <ListItemWrapper data-test="performant-campaign-link">
              <Link campaignId={id} />
            </ListItemWrapper>
          </ListRowWrapper>
        ),
      )}
    </ListWrapper>
  );
};
